import TheGrid from '@/views/sales/distsales/grid'

export default {
  path: '/sales/distsales',
  redirect: '/sales/distsales/index',
  name: 'distsales',
  meta: {
    auth: {
      redirect: {
        name: 'distsales.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Problemas vendas Distribuidores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'distsales.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Vendas'
    }
  }]
}
